import { Phone, MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { SITE } from "../lib/site";
import { useT } from "../lib/i18n";

export default function MobileCallBar() {
  const { pathname } = useLocation();
  const { lang } = useT();
  if (pathname.startsWith("/admin")) return null;
  const wa = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent("Bonjour, je souhaite obtenir un devis pour K'REUSE EXTÉRIEUR.")}`;
  return (
    <>
      <div className="h-16 md:hidden" aria-hidden="true" />
      <nav
        data-testid="mobile-call-bar"
        className="md:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 bg-white/95 backdrop-blur-md border-t border-[#E5EBE5] shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
      >
        <a
          href={`tel:${SITE.phoneRaw}`}
          data-testid="mobile-bar-call"
          className="flex items-center justify-center gap-2 h-16 bg-[#1B5E20] text-white font-semibold active:bg-[#154018] transition-colors"
        >
          <Phone className="w-5 h-5" />
          {lang === "en" ? "Call" : "Appeler"}
        </a>
        <a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          className="flex items-center justify-center gap-2 h-16 bg-[#25D366] text-white font-semibold active:bg-[#1ebe57] transition-colors"
        >
          <MessageCircle className="w-5 h-5" />
          WhatsApp
        </a>
      </nav>
    </>
  );
}
